export const ALGORITHMS = [
  "Bubble Sort",
  "Insertion Sort",
  "Selection Sort",
  "Merge Sort",
  "Quick Sort",
  "Heap Sort",
];

export const MODES = ["One Algorithm", "Two Algorithms"];

export const BUBBLE_SORT = 0;
export const INSERTION_SORT = 0;
export const SELECTION_SORT = 0;
export const MERGE_SORT = 0;
export const QUICK_SORT = 0;
export const HEAP_SORT = 0;

export const ONE_ALGORITHM_MODE = 0;

export const INITIAL_NUMBER_OF_SAMPLES = 20;

export const MIN_NUMBER_OF_SAMPLES = 6;
export const MAX_NUMBER_OF_SAMPLES = 100;

export const MIN_SAMPLE_HEIGHT = 5;
export const MAX_SAMPLE_HEIGHT = 99;

export const LABELED_SAMPLES_ALLOWED = 45;

export const MIN_SORTING_SPEED = 10;
export const MAX_SORTING_SPEED = 500;
